<template>
    <div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'bvr',
    data() {
        return {
            currentSession: null,

        };
    },
    mounted() {
        //return;
        this.setCurrentSession();
    },
    methods: {
        setCurrentSession: async function () {
            this.currentSession = localStorage.getItem(
                "vue-authenticate.vueauth_access_token"
            );

            //console.log('Current session from BVR: ', this.currentSession);

            if (!this.currentSession) {

                this.$store.dispatch('getRandomString', 20).then(async (res) => {
                    this.currentSession = res;

                    await localStorage.setItem(
                        'vue-authenticate.vueauth_access_token',
                        res
                    );

                    this.$store.commit('isAuthenticated', {
                        isAuthenticated:true,
                    });

                    this.getBVR();
                });

            } else
                this.getBVR();

          //await this.$store.dispatch("authenticateUser").then((res) => { this.$router.push({ name: "Search" }); });
        },
        getBVR: async function () {

            await axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + "/session/bvr",
                    {},
                    {
                        params: {
                            session_id: this.currentSession,
                            prod: this.$route.params.prod,
                            id: this.$route.params.id,
                            ts: this.$route.params.ts,
                            key: this.$route.params.key,
                            ornum: this.$route.params.ornum,
                            endsub: this.$route.params.endsub,
                            state: this.$route.params.state || "Other"
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty("data") && res.data.error) {
                        this.$store.commit("SET_ERROR_BIT", true);
                        this.$store.commit(
                            "SET_ERROR_INFO",
                            "<br>" +
                            "Server responded with error = True <br> errorCode: " +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/session/bvr" <br>`
                        );
                        throw new Error(
                            "<br>" +
                            "Server responded with error = True <br> errorCode: " +
                            res.data.errorCode
                        );
                    }

                    if (res.data.success == true) {
                        this.$store.commit('isAuthenticated', {
                             isAuthenticated: true,
                        });
                        this.$router.push({ name: 'Search' });
                    }
                });
        },
    }
};
</script>
